import React from 'react'
import { useTranslation } from 'react-i18next'

import { getCryptoPaymentProviderFlags } from '../../../../model/PaymentProviderId'
import { Note } from '../../../../ui/v2/Note/Note'

interface CryptoNotesInfoProps {
  paymentProviderId?: string
  variant?: 'deposit' | 'form'
}

export const CryptoNotesInfo: React.FC<CryptoNotesInfoProps> = ({
  paymentProviderId,
  variant = 'deposit',
}) => {
  const { t } = useTranslation()

  const {
    isOrbitalCryptoProvider,
    isZotapayCryptoProvider,
    isZotapayMetablocksCryptoProvider,
    isBVNKCryptoProvider,
  } = getCryptoPaymentProviderFlags(paymentProviderId)

  const isCryptoNoteInfoVisible =
    isOrbitalCryptoProvider ||
    isZotapayCryptoProvider ||
    isZotapayMetablocksCryptoProvider ||
    isBVNKCryptoProvider

  if (!isCryptoNoteInfoVisible) {
    return null
  }

  if (variant === 'form') {
    return (
      <div className='mb-4 mt-2'>
        <Note
          id={'wallet-agent-info'}
          type={'info'}
          size={'tiny'}
          message={t('Wallet.Deposit the exact amount initially selected')}
        />
      </div>
    )
  }

  return (
    <>
      <div className='mt-4 mb-2'>
        {' '}
        <Note
          id={'wallet-agent-info'}
          type={'info'}
          size={'tiny'}
          message={t('Wallet.Payments are accepted only in the listed cryptocurrencies')}
        />
      </div>
      <div className='mb-5'>
        <Note
          id={'wallet-agent-info'}
          type={'info'}
          size={'tiny'}
          message={t('Wallet.It is mandatory to complete your payment within the timeframe')}
        />
      </div>
    </>
  )
}
